export default __webpack_public_path__ + "static/media/photo--sm--63.384b525c.jpg";